'use client';

import { FC, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Check, NotificationsCircleOutline } from '@eqi-investimentos/icons/web';
import { Flex, Text, Button, Spinner } from '@eqi-investimentos/react';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useCreateSFOpportunity } from '@/modules/Customer/http/client/mutations/useCreateSFOpportunity';
import { useGetFPGoals } from '@/modules/FinancialPlanning/http/client/useGetFPGoals';
import { getCookie, setCookie } from '@/utils/cookies';
export const PlannerHelpWidget: FC = () => {
  const {
    t
  } = useTranslation('common');
  const {
    data: dataGoals
  } = useGetFPGoals();
  const {
    mutate: createSFOpportunity,
    isPending
  } = useCreateSFOpportunity();
  const [isSuccess, setIsSuccess] = useState(() => getCookie(SENT_NOGOALSSETTED_COOKIE_KEY) === 'true');
  const sendOpportunity = () => {
    createSFOpportunity({
      action: salesforceOpportunityConfig.FP.myGoals.empty.action,
      product: !dataGoals ? salesforceOpportunityConfig.FP.myGoals.empty.product : salesforceOpportunityConfig.FP.myGoals.default.product
    }, {
      onSuccess: () => {
        setIsSuccess(true);
        setCookie(SENT_NOGOALSSETTED_COOKIE_KEY, 'true');
      }
    });
  };
  return <Flex flexDir={{
    base: 'column',
    xl: 'row'
  }} justifyContent="end" w="full" minH="40" data-sentry-element="Flex" data-sentry-component="PlannerHelpWidget" data-sentry-source-file="PlannerHelpWidget.tsx">
      <Flex w="full" flexDir="column" justifyContent="end" gap="5" data-sentry-element="Flex" data-sentry-source-file="PlannerHelpWidget.tsx">
        <NotificationsCircleOutline w="7" h="7" color="var(--color-orange-primary)" data-sentry-element="NotificationsCircleOutline" data-sentry-source-file="PlannerHelpWidget.tsx" />
        <Flex w="full" flexDir="column" gap="0.8rem" data-sentry-element="Flex" data-sentry-source-file="PlannerHelpWidget.tsx">
          <Text fontSize="xl" lineHeight="4" color="rgba(0,0,0,0.8)" data-sentry-element="Text" data-sentry-source-file="PlannerHelpWidget.tsx">
            {t(`screens.financialPlanning.plannerHelp.${isSuccess ? 'opportunity' : 'empty'}.title`)}
          </Text>
          <Text fontWeight="light" lineHeight="4" color="rgba(0,0,0,0.8)" data-sentry-element="Text" data-sentry-source-file="PlannerHelpWidget.tsx">
            {t(`screens.financialPlanning.plannerHelp.${isSuccess ? 'opportunity' : 'empty'}.description`)}
          </Text>
        </Flex>
        <Flex w="full" data-sentry-element="Flex" data-sentry-source-file="PlannerHelpWidget.tsx">
          <Button w="13.5rem" h="10" justifyContent="center" alignSelf="center" gap="3" fontSize="sm" bgColor={isSuccess ? 'rgba(0,0,0, 0.24)' : 'var(--color-orange-primary)'} border="none" color="white" onClick={sendOpportunity} _hover={isSuccess ? 'rgba(0,0,0, 0.24)' : 'var(--color-orange-primary)'} data-sentry-element="Button" data-sentry-source-file="PlannerHelpWidget.tsx">
            {t(`screens.financialPlanning.plannerHelp.${isSuccess ? 'opportunity' : 'empty'}.action`)}
            {isSuccess && <Check w="4" h="4" ml="2" />}
            {isPending && <Spinner size="sm" emptyColor="var(--color-eqi-white)" />}
          </Button>
        </Flex>
      </Flex>
    </Flex>;
};
export const SENT_NOGOALSSETTED_COOKIE_KEY = 'fp-nogoalssetted-sent';